const blue = {
  // color: '#60ACFC',
  background: '#60ACFC'
}
const green = {
  // color: '#5BC49F',
  background: '#5BC49F'
}
const yellow = {
  // color: '#FFB442',
  background: '#FFB442'
}
const orange = {
  // color: '#FF8E4D',
  background: 'rgba(255,142,77)'
}
const red = {
  // color: '#FF7B7B',
  background: '#FF7B7B'
}
const gray = {
  // color: '#666666',
  background: '#A8ABB0'
}

export default {
  blue,
  green,
  yellow,
  orange,
  red,
  gray
}
